import { HttpClient } from '@angular/common/http';
import { MissingTranslationHandler, MissingTranslationHandlerParams } from '@ngx-translate/core';
import { catchError, map, shareReplay, tap } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import get from 'lodash-es/get';

export class ResolveTranslation implements MissingTranslationHandler {
  private loadedNamespaces: { [lang: string]: { [namespace: string]: Observable<any> } } = {};
  private readonly namespacePattern = /^[a-z][a-z0-9_-]*$/;

  constructor(private http: HttpClient) {}

  public handle(params: MissingTranslationHandlerParams) {
    const { key, translateService, interpolateParams } = params;

    const lang = 'US'; // return translateService.currentLang || 'US' once there will be a decision about multilanguage support
    const [namespace, ...paths] = key.split('.');
    if (!this.namespacePattern.test(namespace)) {
      return of(key);
    }
    const path = paths.join('.');
    if (!(lang in this.loadedNamespaces)) {
      this.loadedNamespaces[lang] = {};
    }
    const loaded = this.loadedNamespaces[lang][namespace];
    const translate = map((translations: any) =>
      translations.error ? key : translateService.parser.interpolate(get(translations, path), interpolateParams)
    );
    if (loaded === undefined) {
      this.loadedNamespaces[lang][namespace] = this.http.get(`assets/locale/${lang}/${namespace}.json`).pipe(
        catchError(_ => of({ error: true })),
        tap((translations: any) => {
          const translation = translations.error ? { key } : { [namespace]: translations };
          translateService.setTranslation(lang, translation, true);
        }),
        shareReplay()
      );
    }
    return this.loadedNamespaces[lang][namespace].pipe(translate);
  }
}

export function resolveTranslationFactory(http: HttpClient) {
  return new ResolveTranslation(http);
}
